import React from "react";

export const TextAbout = () => {
  return (
    <div data-aos="fade-left">
      <h2>
        Hi, I'm <b className="bold-shawn-about">Shawn</b>,
      </h2>
      <p className="about-p1">
        I'm a Front End Developer. I'm very passionate and dedicated to my work.
        I love to write clean code, create software, design websites and I love
        what I do. Currently, I'm studying for a graduate degree under the
        Computer Science Department of Southwest Forestry University. I have a
        good idea and
        <b className="bold-about-expertise">
          expertise in front-end technologies such Javascript, React and so on
        </b>
        .
      </p>
    </div>
  );
};
